<template>
  <div v-if="test" class="d-flex flex-column p-3">
    <b-form-input v-model="test.name" placeholder="Введите название теста" @change="save('name')" class="mb-3" />

    <lesson-test-question-tree :isManage="isManage" :testId="test.id" @questionCountChange="onQuestionCountChanged" />

    <template v-if="questionCount">
      <a href="javascript:;" v-b-toggle.collapse-pass-score class="mt-3">Критерий прохождения теста</a>
      <b-collapse id="collapse-pass-score" class="mt-2">
        <input
          type="text"
          v-model="test.pass_score"
          class="form-control"
          style="width: 100px"
          @input="handlePassScoreInput"
          @change="save('pass_score')"
        />
        <div class="text-muted mb-3" style="font-size: 12px">
          Минимальное количество верных ответов для прохождения теста. Оно не может превышать количество вопросов. Если
          вы не укажите количество, то ученику потребуется обязательно верно ответить на все вопросы. В случае неверных
          ответов ученику будет предложено пройти тест еще раз.
        </div>
      </b-collapse>
    </template>
  </div>
</template>

<script>
import LessonTestQuestionTree from "shared/widgets/tree/course/LessonTestQuestionTree.vue";

export default {
  components: { LessonTestQuestionTree },
  name: "TestBlock",
  props: {
    value: null,
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      test: this.value,
      questionCount: null,
    };
  },
  methods: {
    save(fieldName) {
      this.$emit("input", {
        id: this.test.id,
        [fieldName]: this.test[fieldName],
      });
      this.$emit("update");
    },
    onQuestionCountChanged(count) {
      this.questionCount = count;
    },
    handlePassScoreInput({ target: { value } }) {
      let passScore = value.replace(/[^\d+]/gi, "").slice(0, 2);
      if (passScore && passScore > this.questionCount) {
        passScore = this.questionCount;
      }
      this.test.pass_score = passScore;
    },
  },
};
</script>
